import React, { Component } from 'react';

//componentes
import Reporte from './reporte'

class Index extends Component {

    render(){
        return(
            <div>
                <Reporte />
            </div>
        );
    }

}
export default Index;